module.exports = __webpack_public_path__ + "static/img/WebAIMobile.6a4d3f66.png";